import styled from 'styled-components';
import { media } from '@pik/pik-ui';

export const TableContainer = styled.table`
  width: 100%;
  margin-top: -20px;
  
  sup {
    top: -.5em;
    padding-left: 4px;
    font-size: 60%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  
  
    ${({ evenly }) => (evenly ? `
    td:nth-child(1), th:nth-child(1) {
       width: 34.5%;
    }
    
    td:nth-child(2), th:nth-child(2) {
        width: 25.5%;
    }
    
    td:nth-child(3), th:nth-child(3) {
        width: 26%;
    }
    
    td:nth-child(4), th:nth-child(4) {
    
    }
    ` : '')};

  
  
`;

export const HeaderCell = styled.th`
  text-align: left;
  font-family: Graphik;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: #222222;
  border-bottom: 1px solid rgba(180,180,180,0.50);
  padding: 19px 24px 14px 0;
  position: relative;
  
  @media ${media.max768} {
    font-size: 18px;
    line-height: 24px;
    padding: 22px 0px 16px 0px;
  }
    
  ${({ alignRight }) => alignRight && `
    text-align: right;
    padding-right: 0 !important; 
  `}
  
  ${({ width }) => width && `width: ${width}px;`}
`;

export const ContentCell = styled.td`
  text-align: left;
  font-family: Graphik;
  font-size: 16px;
  color: #333333;
  border-bottom: 1px solid rgba(180,180,180,0.50);
  padding: 16px 30px 16px 0;
  line-height: 24px;
  max-width: 492px;
  box-sizing: border-box;
  white-space: pre-wrap;
  
  ${({ alignRight }) => alignRight && `
    text-align: right;
    padding-right: 0 !important; 
  `}

  @media ${media.max768} {
    font-size: 16px;
    padding: 14px 16px 16px 0;
    line-height: 24px;
    min-width: 80px;
  }
`;

export const SubText = styled.span`
  display: block;
  font-family: Graphik;
  font-size: 12px;
  color: #808080;
  letter-spacing: 0;
  line-height: 16px;

  @media ${media.max768} {
    
  }
`;
